import { TreeProgramTopHeader, VersionCompareSelectorWrapper } from 'components/common';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { SinglePageTitle } from 'components/Dashboards/Project/Components/VersionCompare/components/SinglePageTitle/singlePageTitle';
import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { projectConfig } from 'components/Dashboards/Project/ProjectWrapper/projectConfig';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import LargestAddedActivities from 'components/widgets/LargestAddedActivities/largestAddedActivities';

export const LargestAddedActivitiesSinglePage = () => {
    useFullStoryPageView({ pageName: projectConfig.versionCompare.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader
                            pageTitle={<SinglePageTitle title={projectConfig.largestAddedActivities.title} />}
                            isDisabled={true}
                        />
                        <VersionCompareSelectorWrapper />
                    </VersionSection>
                </VersionWrapper>
            </HeaderWrapper>
            <MainContent>
                <PageWidgetWrapper>
                    <LargestAddedActivities isSinglePage={true} />
                </PageWidgetWrapper>
            </MainContent>
            <MainCardRoutingModal queryKeys={['largestAddedActivitiesTableData']} />
        </PageContainer>
    );
};
